import { ButtonHTMLAttributes } from 'react'

import {
  StyledBackIcon,
  StyledContainer
} from './style'
import BackArrow from '../../assets/icons/arrow-right.svg'

export enum Variant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary'
}

export interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string
  disabled?: boolean
  variant?: Variant
  className?: string
  onClick?: (event: any) => void
  isLoading?: boolean
}

const Button = ({
  label,
  disabled = false,
  variant = Variant.PRIMARY,
  isLoading = false,
  type,
  ...props
}: IButtonProps): JSX.Element => {
  return (
    <StyledContainer
      as='button'
      isDisabled={disabled ||
        isLoading
      }
      {...{
        variant, type, ...props
      }}
    >
      {variant === Variant.SECONDARY &&
        <StyledBackIcon src={BackArrow} />
      }
      {label}
    </StyledContainer>
  )
}

export default Button
